/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./Footer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { useElementSize } from '../../hooks/useElementSize';
import { FooterAIBrand } from './components/FooterAIBrand';
import { FooterDisclaimer } from './components/FooterDisclaimer';
import { AI_BREAKPOINTS, ROVO_BREAKPOINTS } from './constants';
import messages from './messages';
var footerStyles = {
  default: "_zulp1b66 _1e0c1txw _1n261g80 _19bvpxbi _u5f3pxbi _ca0qu2gc _n3tdu2gc _15a5nqa1 _4cvr1h6o _1bah1yb4 _1i53muej _uwhke4h9"
};
export function Footer(_ref) {
  var brand = _ref.brand,
    showDisclaimer = _ref.showDisclaimer,
    disclaimer = _ref.disclaimer,
    showBetaLozenge = _ref.showBetaLozenge;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useElementSize = useElementSize(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    setElement = _useElementSize2[0],
    width = _useElementSize2[1].width;
  var appearance = useMemo(function () {
    if (brand === 'atlassian-intelligence') {
      if (width < AI_BREAKPOINTS.medium) {
        return 'small';
      }
      if (width < AI_BREAKPOINTS.large) {
        return 'medium';
      }
      return 'large';
    } else {
      if (width < ROVO_BREAKPOINTS.medium) {
        return 'small';
      }
      if (width < ROVO_BREAKPOINTS.large) {
        return 'medium';
      }
      return 'large';
    }
  }, [width, brand]);
  return /*#__PURE__*/React.createElement(Box, {
    ref: setElement,
    xcss: footerStyles.default,
    backgroundColor: "elevation.surface"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050"
  }, showBetaLozenge && /*#__PURE__*/React.createElement(Lozenge, {
    testId: "beta-lozenge"
  }, formatMessage(messages.betaLabel)), showDisclaimer ? /*#__PURE__*/React.createElement(FooterDisclaimer, {
    disclaimer: disclaimer,
    appearance: appearance
  }) : /*#__PURE__*/React.createElement(Box, null)), !fg('ai-smart-button-team-25') && /*#__PURE__*/React.createElement(FooterAIBrand, {
    brand: brand,
    appearance: appearance
  }));
}